const MonitoringPlatformIcon =()=>{
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 40 32" fill="none">
        <path d="M8 2C5.79375 2 4 3.79375 4 6V22H8V6H32V22H36V6C36 3.79375 34.2062 2 32 2H8ZM1.2 24C0.5375 24 0 24.5375 0 25.2C0 27.85 2.15 30 4.8 30H35.2C37.85 30 40 27.85 40 25.2C40 24.5375 39.4625 24 38.8 24H1.2Z" fill="currentColor"/>
        </svg>
    );
}
export default MonitoringPlatformIcon;